import { motion } from "framer-motion";

export default function SectionHeading({ badge, title, subtitle, center = true }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      className={`mb-12 lg:mb-16 ${center ? "text-center" : ""}`}
    >
      {badge && <span className="premium-badge mb-4">{badge}</span>}
      <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white tracking-tight">{title}</h2>
      {subtitle && (
        <p className={`mt-4 text-white/60 text-lg max-w-2xl leading-relaxed ${center ? "mx-auto" : ""}`}>
          {subtitle}
        </p>
      )}
    </motion.div>
  );
}
